// src/components/common/PermissionDenied.js
import React from 'react';
import { Link } from 'react-router-dom';

const PermissionDenied = ({ message }) => {
  return (
    <div className="error-container">
      <div className="error-card">
        <div className="error-icon">
          <i className="bi bi-shield-lock"></i>
        </div>
        <h2>Permission Denied</h2>
        <p className="error-message">{message || "You don't have permission to access this resource."}</p>
        
        <div className="solution-steps">
          <h4>To resolve this:</h4>
          <ol>
            <li>Ensure your Firestore user document has <code>role: "superadmin"</code></li>
            <li>Log out and log back in after updating your role</li>
            <li>Contact your system administrator if you need superadmin access</li>
          </ol>
        </div>
        
        <div className="error-actions">
          <button 
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            <i className="bi bi-arrow-clockwise"></i> Reload Page
          </button>
          <Link to="/" className="btn btn-secondary">
            <i className="bi bi-house-door"></i> Go to Home
          </Link>
        </div>
        
        <div className="admin-contact">
          <p>
            <i className="bi bi-info-circle"></i> Contact your administrator with your user ID: 
            <code>{localStorage.getItem('userId') || 'N/A'}</code>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PermissionDenied;